import { takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as constants from './constants';

function* showSuccessNotification({ payload: options }) {
  yield toast.success(options.message);
}

export function* showSuccessNotificationWatcher() {
  yield takeEvery(constants.SHOW_SUCCESS_NOTIFICATION, showSuccessNotification);
}

function* showErrorNotification({ payload: options }) {
  yield toast.error(options.message);
}

export function* showErrorNotificationWatcher() {
  yield takeEvery(constants.SHOW_ERROR_NOTIFICATION, showErrorNotification);
}

function* showWarningNotification({ payload: options }) {
  yield toast.warn(options.message);
}

export function* showWarningNotificationWatcher() {
  yield takeEvery(constants.SHOW_WARNING_NOTIFICATION, showWarningNotification);
}
